import { Injectable, EventEmitter } from '@angular/core';

@Injectable()
export class NavigationEmitterService {
  data = new EventEmitter();

  notify(data: any) {
    this.data.emit(data);
  }
}
